"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.animator = void 0;
var animejs_1 = __importDefault(require("animejs"));
var playBleeps = function (bleeps) {
    var _a;
    (_a = bleeps.readout) === null || _a === void 0 ? void 0 : _a.play();
};
var stopBleeps = function (bleeps) {
    var _a, _b;
    if ((_a = bleeps.readout) === null || _a === void 0 ? void 0 : _a.getIsPlaying()) {
        (_b = bleeps.readout) === null || _b === void 0 ? void 0 : _b.stop();
    }
};
var stopCodeBlockAnimation = function (animator, containerRef) {
    if (containerRef.current) {
        var container = containerRef.current;
        var elements = container.querySelectorAll([
            '.arwes-code-block__wrap',
            '.arwes-code-block__bg',
            '.arwes-code-block__lang-bg',
            '.arwes-code-block__line'
        ].join(','));
        animejs_1.default.remove(elements);
    }
};
var startCodeBlockAnimation = function (animator, containerRef) {
    stopCodeBlockAnimation(animator, containerRef);
    var duration = animator.duration, flow = animator.flow;
    var isEntering = flow.entering || flow.entered;
    var container = containerRef.current;
    animejs_1.default({
        targets: container.querySelector('.arwes-code-block__wrap'),
        duration: isEntering ? duration.enter : duration.exit,
        easing: 'easeInExpo',
        opacity: isEntering ? [0, 1] : [1, 0]
    });
    animejs_1.default({
        targets: container.querySelectorAll('.arwes-code-block__bg, .arwes-code-block__lang-bg'),
        duration: isEntering ? duration.enter : duration.exit,
        easing: 'easeOutSine',
        opacity: isEntering ? [0, 1] : [1, 0]
    });
    animejs_1.default({
        targets: container.querySelectorAll('.arwes-code-block__line'),
        duration: isEntering ? duration.enter : duration.exit,
        easing: 'easeOutSine',
        width: isEntering ? [0, '100%'] : ['100%', 0]
    });
};
var onAnimateEntering = function (animator, containerRef, bleeps) {
    startCodeBlockAnimation(animator, containerRef);
    playBleeps(bleeps);
};
var onAnimateEntered = function (animator, containerRef, bleeps) {
    stopBleeps(bleeps);
};
var onAnimateExiting = function (animator, containerRef) {
    startCodeBlockAnimation(animator, containerRef);
};
var onAnimateUnmount = function (animator, containerRef, bleeps) {
    stopCodeBlockAnimation(animator, containerRef);
    stopBleeps(bleeps);
};
var animator = {
    onAnimateEntering: onAnimateEntering,
    onAnimateEntered: onAnimateEntered,
    onAnimateExiting: onAnimateExiting,
    onAnimateUnmount: onAnimateUnmount
};
exports.animator = animator;
